















import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { log } from '@/log'
import { ApiProductclass } from '@/models/api/productclass'

/**
 * 商品一覧の表示を共通化するために使用.
 *
 * TODO:
 * keyをこのコンポーネント内で解決可能にしたい.
 * 一部スタイルがDOM構造に依存しているので、一旦、各自利用コンポーネント側でkey指定.
 */
@Component({
  components: {
  },
})
export default class ItemList extends Vue {
  @Prop({ default: 'div' })
  tag: string

  @Prop({ required: true })
  itemList: any[]

  get viewList(): any[] {
    return this.itemList.filter((item) => {
      const fku = new ApiProductclass(item)

      if (fku.root === null) {
        log.warn(`fku ${item.id} not has root, so skipped`)

        return false
      }

      return true
    })
  }
}
